import apiClient from 'utilities/apiClient';

export const dashboard_counts = (payload) => {
  console.log('payload', payload);
  return apiClient.get(`${apiClient.Urls.dashboard_counts}`, payload, true);
};

export const dashboard_api = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.dashboard_api}/${url}`, payload, true);
};

export const bulk_gift_configs = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.apiUrl}/bulk-gift-configs`,
    payload,
    true
  );
};

export const user_bulk_upload_direct_approve = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.apiUrl}/user-bulk-upload-direct-approve`,
    payload,
    true,
    'file'
  );
};

export const declaration_configs = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.apiUrl}/declaration-configs`,
    payload,
    true
  );
};

export const submit_declaration = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.apiUrl}/submit-declaration`,
    payload,
    true
  );
};
